export default __webpack_public_path__ + "static/media/logo.757256d4.png";